import * as React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchProductWP, fetchOneProductWP } from '../actions/posts';
import { fetchCategoriesProductWP } from '../actions/categories';
import mapStateToProps from '../utils/mapStateToProps';
import mapDispatchToProps from '../utils/mapDispatchToProps';
import OwlCarousel from 'react-owl-carousel2';
import renderHTML from 'react-render-html';
import { isEmpty } from '../helpers/index';
import api from '../services';

class DetailProduct extends React.Component<any, any> {

	constructor(props: any) {
		super(props);
		this.state = {
			product_related: [],
			loading: true
		}
	}

	componentDidMount() {
		if (this.props.match.params.post_id) {
			this.props.fetchOneProductWP({
				product_id: this.props.match.params.post_id
			});
		}
	}

	componentWillReceiveProps(nextProps) {
		if(nextProps.productsOneWP.loading === false) {
			var element: any = document.getElementById('loading-data');
			element.innerHTML = '';
			this.setState({
				loading: false
			});
			api.getRelatedProduct({
				body: {
					related: nextProps.productsOneWP.data.related_ids
				}
			}).then(res => {
				this.setState({
					product_related: res.data
				});
			})
		}
	}

	shouldComponentUpdate(nextProps) {
		if (nextProps.productsOneWP.loading) {
			return false;
		} else {
			return true;
		}
	}

	redirectProduct = (item) => {
		var element: any = document.getElementById('loading-data');
		element.innerHTML = `<div class="loadingPage active"> <img src=${require('../img/Spin-1s-58px.gif')}></div>`;
		window.scrollTo(110, 110);
		this.props.fetchOneProductWP({
			product_id: item.id
		});
	};


	componentDidUpdate(prevProps, prevState) {
		if(isEmpty(prevProps.productsOneWP.data)) {
			document.title = this.props.t(prevProps.productsOneWP.data.name);
		}
	}


	render() {
		const { productsOneWP, t } = this.props;
		const options = {
			items: 3,
			margin: 30,
			dots: false,
			rewind: true,
			autoplay: true,
			loop: true
		};

		var img_gallery = '';

		if (isEmpty(productsOneWP.data)) {
			img_gallery = productsOneWP.data.images.map((item, index) => {
				if (index == 0) {
					return (
						<div key={item.id} className="images col-sm-12">
							<img src={require('../img/img-maskPrd600.png')}
							     style={{ background: `url(${item.src}) no-repeat center center/cover` }}/>
						</div>
					);
				} else {
					return (
						<div key={item.id} className="thumbnails columns-3 col-sm-4">
							<img src={require('../img/img-maskPrd.png')} style={{ background: `url(${item.src}) no-repeat center center/cover` }}/>
						</div>
					)
				}
			});
		}

		var related_product = this.state.product_related.map(item => {
			var link = '';
			if (item.images.length > 0) {
				link = item.images[0]['src'];
			}
			return (
				<div onClick={() => this.redirectProduct(item) } key={item.id} className="itemProducts">
					<Link to={`/product/${item.id}/${item.slug}`}>
					    <span className="imgPrd">
						    <img src={require('../img/img-maskPrd.png')}
						         style={{ background: `url(${link}) no-repeat center center/cover` }}/>
					    </span>
						<h2 className="itemTitle">{item.name}</h2>
					</Link>
				</div>
			)
		});

		const owlSlides = related_product.length == 0 ? <div></div> :
            <OwlCarousel options={options}>
                {related_product}
            </OwlCarousel>;

		return (
			<div className="productsWrap">
				<div className="container">
					<div className="pageTitle">
						Cửa hàng
					</div>
					<div className="row">
						<div className="col-sm-12">
							<div className="shopProductsDetail">
								<div className="row">
									<div className="col-sm-6">
										<div className="row">
											{img_gallery}
										</div>
									</div>
									<div className="col-sm-6">
										<div className="product-summary">
											<div className="titlePrd">
												{productsOneWP.data.name}
											</div>
											<div className="descriptionPrd content-responsive postContent">
												{renderHTML(`${productsOneWP.data.description}`)}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="relatedPrd">
						<h4>{t('related_product')}</h4>
						<div className="listPrd">
							{owlSlides}
						</div>
					</div>
				</div>
				<div id="loading-data"></div>
				{this.state.loading ? <div className="loadingPage active"> <img src={require('../img/Spin-1s-58px.gif')}/></div> : '' }
			</div>
		);
	}
}

export default connect(mapStateToProps([
	'productsWP', 'categoriesProductWP', 'productsOneWP'
]), mapDispatchToProps({
	fetchProductWP, fetchCategoriesProductWP, fetchOneProductWP
}))(translate('translations')(DetailProduct));



// WEBPACK FOOTER //
// ./src/containers/DetailProduct.tsx